import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=675ef7d9&scoped=true&"
import script from "./Thanks.vue?vue&type=script&lang=ts&"
export * from "./Thanks.vue?vue&type=script&lang=ts&"
import style0 from "./Thanks.vue?vue&type=style&index=0&id=675ef7d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ef7d9",
  null
  
)

export default component.exports